import { useEffect } from "react";

export function usePosHotkeys({ focusSearch, openPayment, clearCart, cartLength }) {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "F2") { e.preventDefault(); focusSearch(); }
      else if (e.key === "F9") { e.preventDefault(); if (cartLength > 0) openPayment(); }
      else if (e.key === "Escape" && cartLength > 0) {
        if (window.confirm("Xóa toàn bộ giỏ hàng?")) clearCart();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [focusSearch, openPayment, clearCart, cartLength]);
}
